var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_ALERTS_DASHBOARD, GET_ALERTS_DASHBOARD_SUCCESS, GET_ALERTS_DASHBOARD_FAILURE, UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER, CLEAR_ALERTS_DASHBOARD_STATE, SET_ALERTS_FILTER, GET_ALERTS_DEVICES, GET_ALERTS_DEVICES_SUCCESS, GET_ALERTS_DEVICES_FAILURE, GET_ALERTS_SOS_SUCCESS, GET_ALERTS_SOS, GET_ALERTS_SOS_FAILURE, } from './AlertsDashboard.types';
export var INITIAL_STATE = {
    loading: false,
    seniorsData: [],
    devicesData: null,
    sosFallsData: null,
    error: null,
    totalRows: 0,
    currentPage: 1,
    lastEvaluatedKey: '',
    activeFilter: 'all',
};
export var alertsDashboardReducer = function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        // ----------------- SENIORS -----------------
        case GET_ALERTS_DASHBOARD:
            return __assign(__assign({}, state), { loading: true, error: null });
        case GET_ALERTS_DASHBOARD_SUCCESS:
            return __assign(__assign({}, state), { loading: false, seniorsData: action.payload.seniorsData, lastEvaluatedKey: action.payload.lastEvaluatedKey });
        case GET_ALERTS_DASHBOARD_FAILURE:
            return __assign(__assign({}, state), { loading: false, error: action.payload, seniorsData: [] });
        // ----------------- DEVICES -----------------
        case GET_ALERTS_DEVICES:
            return __assign(__assign({}, state), { loading: true, error: null });
        case GET_ALERTS_DEVICES_SUCCESS:
            return __assign(__assign({}, state), { loading: false, devicesData: action.payload || null, error: null });
        case GET_ALERTS_DEVICES_FAILURE:
            return __assign(__assign({}, state), { loading: false, error: action.payload, devicesData: null });
        // SOS And Falls Card-:
        case GET_ALERTS_SOS:
            return __assign(__assign({}, state), { loading: true, error: null });
        case GET_ALERTS_SOS_SUCCESS:
            return __assign(__assign({}, state), { loading: false, sosFallsData: action.payload || { sos: 0, falls: 0 }, error: null });
        case GET_ALERTS_SOS_FAILURE:
            return __assign(__assign({}, state), { loading: false, sosFallsData: null, error: action.payload });
        // ----------------- PAGINATION & FILTERS -----------------
        case UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER:
            return __assign(__assign({}, state), { currentPage: action.payload });
        case SET_ALERTS_FILTER:
            return __assign(__assign({}, state), { activeFilter: action.payload, currentPage: 1, lastEvaluatedKey: '' });
        case CLEAR_ALERTS_DASHBOARD_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
